import { createFileRoute } from '@tanstack/react-router';
import { CatalogoPageDefault } from '@/features/catalogo/page/default/CatalogoPageDefault';

export const Route = createFileRoute('/p/catalogo/$slug/_default')({
    component: CatalogoPageDefault,
});
